export default "__VITE_ASSET__CtYYlAvD__"